/**
 * BUG-2837 / TIC-13998: headers for a file upload to env.uploadDocumentUrl (apps2 /api/uploadImages).
 *
 * The upload service on KWC, Dadus and Chocolala answers 401 "Unauthorized" to a request
 * without an Authorization header (seen from 2026-11-04). The customer drawers already sent
 * the POS login token; Remove Cash, Bank Transfer, the customer document modal and the
 * custom attribute upload did not. The token is the POS's own login (getOAuthHeaders,
 * BUG-2594), never read from document.cookie directly. With no login the header is left
 * out, as before.
 */
import { getOAuthHeaders } from "../constants/oAuthValidation";

export const uploadDocumentHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  let token;
  try {
    token = getOAuthHeaders()?.access_token;
  } catch (err) {
    console.warn("[Upload] could not read the POS login for the upload", err?.message);
    token = undefined;
  }
  if (token) headers.Authorization = token;
  return headers;
};
